import React from 'react';
import { AdminRoutePath } from 'src/entities/adminRoute';
import { useVacancyModerationBadgeCount } from 'src/entities/vacancy';
import { generateAdminPath } from 'src/app/shared/utils/generateAdminPath';
import { SidebarSectionItem } from '../../sectionItem';

export const ModerationVacanciesSidebarItem: React.FC = () => {
  const count = useVacancyModerationBadgeCount();

  return (
    <SidebarSectionItem
      badgeValue={count > 0 ? count : undefined}
      href={generateAdminPath(AdminRoutePath.ModerationVacancies)}
      title="Вакансии"
    />
  );
};
